var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg5YearChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 84,
    viewBox: "0 0 86 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    width: 14,
    height: 61.0909,
    rx: 3,
    fill: "#00c6c4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 9.54544,
    width: 14,
    height: 51.5455,
    rx: 3,
    fill: "#00c6c4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 22.8599,
    width: 14,
    height: 38.1818,
    rx: 3,
    fill: "#00c6c4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 38.1326,
    width: 14,
    height: 32.4545,
    rx: 3,
    fill: "#00c6c4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 52.4508,
    width: 14,
    height: 21,
    rx: 3,
    fill: "#00c6c4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 22.9091H86V81C86 82.6569 84.6569 84 83 84H75C73.3431 84 72 82.6569 72 81V22.9091Z",
    fill: "#7163D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38.1818H68V81C68 82.6569 66.6569 84 65 84H57C55.3431 84 54 82.6569 54 81V38.1818Z",
    fill: "#7163D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 50.5909H50V81C50 82.6568 48.6569 84 47 84H39C37.3431 84 36 82.6568 36 81V50.5909Z",
    fill: "#7163D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 63H32V81C32 82.6569 30.6569 84 29 84H21C19.3431 84 18 82.6569 18 81V63Z",
    fill: "#7163D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 68.7273H14V81C14 82.6569 12.6569 84 11 84H3C1.34315 84 0 82.6569 0 81V68.7273Z",
    fill: "#7163D0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5YearChart);
export default __webpack_public_path__ + "static/media/5-year-chart.fd9012bf.svg";
export { ForwardRef as ReactComponent };